import React from "react";
import msgIcon01 from "../images/msg_icon_01.png";
import { Link } from "react-router-dom";

export default function FindIdPasswordCompletePage() {
  return (
    <section class="mbSection msgSection">
      <div class="msg-wrap">
        <div class="msg-cont-box">
          <div class="msg-icon">
            <img src={msgIcon01} alt="아이디/비밀번호 찾기 완료" />
          </div>
          <p class="msg-sub">아이디/비밀번호 찾기 완료</p>
          <p class="msg-title">
            가입 시 작성하신 이메일로
            <br />
            정보가 전달되었습니다.
          </p>
        </div>
      </div>
      <div class="btmBtnWrap">
        <Link class="btn btn-black" to="/">
          로그인 화면으로
        </Link>
      </div>
    </section>

    // <!-- 이메일 인증번호 모달 -->
    // <div class="modal-overlay" id="emailModal" style="display: none;">
    //     <div class="modal">
    //         <button class="btn-close"><i class="x-icon"></i></button>
    //         <div class="modal-icon">
    //             <img src="/images/modal-icon_01.png" alt="확인">
    //         </div>
    //         <p class="modal-title">이메일로 전달받은<br>인증번호를 입력해주세요.</p>
    //         <p class="modal-desc">네트워크 환경에 따라 시간이 걸릴 수 있습니다.</p>
    //         <input type="text" placeholder="인증번호 입력" class="modal-input">
    //         <button class="btn btn-black">확인</button>
    //     </div>
    // </div>
  );
}
